import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { Download } from '@mui/icons-material';
import { getDocumentDisplayName } from '../../utils/storeCertificateDocuments';

const CertificateField = ({
  certificateNumber,
  document: certDoc,
  onDownload,
  downloading = false,
  size = 'small'
}) => {
  const fileName = getDocumentDisplayName(certDoc);
  const hasDownload = Boolean(onDownload);
  const numberLabel = certificateNumber || (hasDownload && certDoc ? 'On file' : '—');

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, minWidth: 100 }}>
      <Typography variant="body2">
        {numberLabel}
      </Typography>
      {fileName && hasDownload && (
        <Typography variant="caption" color="text.secondary" noWrap title={fileName}>
          {fileName}
        </Typography>
      )}
      {hasDownload && (
        <Button
          size={size}
          variant="outlined"
          startIcon={<Download />}
          onClick={(event) => {
            event.stopPropagation();
            onDownload();
          }}
          disabled={downloading}
          sx={{ alignSelf: 'flex-start' }}
        >
          Download
        </Button>
      )}
    </Box>
  );
};

export default CertificateField;
